import { render, staticRenderFns } from "./bid_form.vue?vue&type=template&id=6ad05f08&scoped=true&"
import script from "./bid_form.vue?vue&type=script&lang=js&"
export * from "./bid_form.vue?vue&type=script&lang=js&"
import style0 from "./bid_form.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./bid_form.vue?vue&type=style&index=1&id=6ad05f08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad05f08",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCheckbox,VForm,VSelect,VTextField,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ad05f08')) {
      api.createRecord('6ad05f08', component.options)
    } else {
      api.reload('6ad05f08', component.options)
    }
    module.hot.accept("./bid_form.vue?vue&type=template&id=6ad05f08&scoped=true&", function () {
      api.rerender('6ad05f08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/bid_form.vue"
export default component.exports